import { Component } from "react";
import Moment from "react-moment";
import withAuth from "../components/withAuth";
import { withStyles } from "@mui/styles";
import PropTypes from "prop-types";
import "../components/Parameters.css";
import { compose } from "redux";
import { loadActiveUser } from "../redux/users/usersActions";
import { connect } from "react-redux";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { getHabilitations } from "../redux/habilitations/habilitationsActions";
import "./CarteHabilitation.css";

const CustomTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        padding: "4px 4px 4px 4px",
    },
    body: {
        fontSize: 14,
        maxWidth: "40px",
        padding: "4px 4px 4px 4px",
        overflowWrap: "break-word",
    },
}))(TableCell);

const styles = (theme) => ({
    root: {
        width: "100%",
        marginTop: theme.spacing(3),
        overflowX: "auto",
    },
    table: {
        minWidth: 700,
    },
    row: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.background.default,
        },
    },
});

class CarteHabilitation extends Component {
    componentDidMount() {
        this.props.loadActiveUser();
        this.props.getHabilitations(this.props.activeUser.emp_id);
    }

    render() {
        const { classes } = this.props;
        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                <div className="container without-side-padding">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 carteHabilitation without-side-padding">
                            <hr />
                            <Paper elevation={4} className="paper-content paper-table">
                                <Table
                                    loadingtext="Chargement..."
                                    style={{ tableLayout: "auto" }}
                                    nodatatext="Aucune donnée à afficher"
                                    pagetext="Page"
                                    oftext="sur"
                                    rowstext="lignes"
                                >
                                    <TableHead>
                                        <TableRow>
                                            <CustomTableCell style={{ minWidth: "60px" }}>{"Code"}</CustomTableCell>
                                            <CustomTableCell style={{ minWidth: "90px" }}>
                                                {"Désignation"}
                                            </CustomTableCell>
                                            <CustomTableCell style={{ minWidth: "60px" }}>
                                                {"Champ d'application"}
                                            </CustomTableCell>
                                            <CustomTableCell style={{ minWidth: "90px" }}>
                                                {"Date de validation"}
                                            </CustomTableCell>
                                            <CustomTableCell style={{ minWidth: "90px" }}>{"Validité"}</CustomTableCell>
                                            <CustomTableCell style={{ minWidth: "90px" }}>
                                                {"Responsable"}
                                            </CustomTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.props.habilitations.map((habilitation, index) => {
                                            return (
                                                <TableRow className={classes.row} key={index}>
                                                    <CustomTableCell
                                                        component="th"
                                                        scope="row"
                                                        style={{ minWidth: "60px" }}
                                                    >
                                                        {habilitation.code}
                                                    </CustomTableCell>
                                                    <CustomTableCell style={{ minWidth: "90px" }}>
                                                        {habilitation.name}
                                                    </CustomTableCell>
                                                    <CustomTableCell style={{ minWidth: "60px" }}>
                                                        {habilitation.application_field}
                                                    </CustomTableCell>
                                                    <CustomTableCell style={{ minWidth: "90px" }}>
                                                        {habilitation.validation_date ? (
                                                            <Moment
                                                                format="DD/MM/YYYY"
                                                                date={habilitation.validation_date}
                                                            />
                                                        ) : (
                                                            ""
                                                        )}
                                                    </CustomTableCell>
                                                    <CustomTableCell style={{ minWidth: "90px" }}>
                                                        {habilitation.end_date ? (
                                                            <Moment format="DD/MM/YYYY" date={habilitation.end_date} />
                                                        ) : (
                                                            ""
                                                        )}
                                                    </CustomTableCell>
                                                    <CustomTableCell style={{ minWidth: "90px" }}>
                                                        {habilitation.signer_user}
                                                    </CustomTableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </Paper>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CarteHabilitation.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        habilitations: state.habilitations,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadActiveUser: () => dispatch(loadActiveUser()),
        getHabilitations: (empId) => dispatch(getHabilitations(empId)),
    };
};

export default compose(withAuth, withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(CarteHabilitation);
